import { Fade } from "@mui/material";
import ReactCropper from "./react-cropper/react-cropper";
import { useCallback, useEffect, useRef } from "react";
import { useAppStore } from "@src/v3.0.0/store/app";
import { useRepeater } from "@src/v3.0.0/hooks/repeater/use-repeater";
import { ZOOM_WHEEL_STEP } from "@src/v3.0.0/lib/constants";
import { useCropperStore } from "@src/v3.0.0/store/cropper/cropper-store";
import { isItDark } from "@src/v3.0.0/lib/utils";

function CustomReactCropper(props) {
  const {cropperConfig} = props;
  const repeater = useRepeater();
  const appStore = useAppStore();
  const appIsReady = useAppStore(state => state.isReady());
  const cropperRef = useRef();
  const eventRef = useRef();
  const cropperStore = useCropperStore();

  const onCropperInitialized = cropperInstance => {
    cropperInstance.preset = cropperStore.preset;
  };

  const onCropperReady = event => {
    console.log('ready');
    cropperStore.setCropperChanged();

    const repeaterChanged = repeater.getStatus();
    const cropperInstance = event.target.cropper;

    isItDark(cropperInstance.image.src, isDark => {
      useCropperStore.setState({ isDark });
    });

    cropperInstance._initFrame(repeaterChanged);
    repeater.save();
    
    // app & cropper ready
    cropperStore.setElement(event.target);
    cropperStore.setCropperReady();
    appStore.setReady();
  };
  
  const zoomID = useRef();
  useEffect(() => { clearTimeout(zoomID.current); }, []);

  const onCrop = useCallback(e => {

    (async () => {
      const { top, left, scale } = await e.target.cropper._updateTranslate();
      const typeEvent = eventRef.current?.type;

      // if(['zoom', 'zoomed'].includes(typeEvent)) {
      //   clearTimeout(zoomID.current);
        zoomID.current = setTimeout(() => {
          cropperStore.updatePreset({ 
            zoom: cropperStore.getCropper()._getZoomFactor(),
            top, 
            left,
            scale
          });
        }, 150);
      // }
      
      eventRef.current = e;
    })();
    
  }, [cropperStore.updatePreset]);

  const onCropEnd = async e => {
    const { top, left } = await e.target.cropper._updateTranslate();
    cropperStore.updatePreset({ top, left });
    console.log('END');
    eventRef.current = e;
  };

  const onReplace = e => {
  };

  const onCropStart = e => {
    console.log('zoom', e);
  };

  const onWheelEnd = e => {
    e.target.cropper._updateTranslate();
    eventRef.current = e;
  };

  const onWheelStart = e => {
    e.target.cropper._updateTranslate();
    eventRef.current = e;
  };

  const onZoom = e => {
    eventRef.current = e;
  }

  const onZoomed = e => {
    eventRef.current = e;
  }

  useEffect(() => () => {
    appStore.setIdle();
    cropperStore.setCropperNone();
  }, []);

  if (!repeater.image) {
    return null;
  }

  return (
    <>
      <Fade in={appIsReady}>
        <span>
          <ReactCropper
            ref={cropperRef}
            src={repeater.image}
            guides={false}
            viewMode={1}
            dragMode="move"
            cropBoxMovable={false}
            cropBoxResizable={false}
            toggleDragModeOnDblclick={false}
            zoomable
            background={false}
            wheelZoomRatio={ZOOM_WHEEL_STEP}
            // onReplace={onReplace}
            ready={onCropperReady}
            onInitialized={onCropperInitialized}
            cropstart={onCropStart}
            zoom={onZoom}
            zoomed={onZoomed}
            cropend={onCropEnd}
            crop={onCrop}
            wheel={onWheelStart}
            wheelend={onWheelEnd}
            {...cropperConfig}
          />
        </span>
      </Fade>
    </>
   
  );
}

export default CustomReactCropper;
